import { render, staticRenderFns } from "./question-manage.vue?vue&type=template&id=e272fa5c&scoped=true"
import script from "./question-manage.vue?vue&type=script&lang=js"
export * from "./question-manage.vue?vue&type=script&lang=js"
import style0 from "./question-manage.vue?vue&type=style&index=0&id=e272fa5c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e272fa5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e272fa5c')) {
      api.createRecord('e272fa5c', component.options)
    } else {
      api.reload('e272fa5c', component.options)
    }
    module.hot.accept("./question-manage.vue?vue&type=template&id=e272fa5c&scoped=true", function () {
      api.rerender('e272fa5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/question-manage.vue"
export default component.exports